export default __webpack_public_path__ + "static/media/Thumbs.13bb1e20.db";